import { cn } from "@/lib/utils";

const BG = {
    white: "bg-white",
    pink: "bg-brand-pink",
    yellow: "bg-brand-yellow",
    green: "bg-brand-green",
    blue: "bg-brand-blue text-white",
    orange: "bg-brand-orange text-white",
    cream: "bg-cream",
};

export default function BrutalCard({
    bg = "white",
    className,
    children,
    interactive = false,
    ...props
}) {
    return (
        <div
            className={cn(
                "border-[3px] border-ink rounded-2xl shadow-brutal-lg p-6 md:p-8",
                BG[bg],
                interactive &&
                    "transition-all duration-200 hover:-translate-y-1 hover:-translate-x-1 hover:shadow-brutal-xl",
                className
            )}
            {...props}
        >
            {children}
        </div>
    );
}
